import { render, staticRenderFns } from "./SecondRatioCard.vue?vue&type=template&id=ea366f58&"
import script from "./SecondRatioCard.vue?vue&type=script&lang=js&"
export * from "./SecondRatioCard.vue?vue&type=script&lang=js&"
import style0 from "./SecondRatioCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports